var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadCloud(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "download-cloud"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M8.73125 16.4574L12.0021 19.7282M12.0021 19.7282L15.2729 16.4574M12.0021 19.7282V12.3689M19.2633 17.3487C19.9742 16.8488 20.5073 16.1353 20.7853 15.3119C21.0632 14.4885 21.0715 13.5979 20.8091 12.7694C20.5466 11.9409 20.0269 11.2176 19.3255 10.7045C18.6241 10.1913 17.7774 9.91507 16.9083 9.91575H15.878C15.632 8.95729 15.1719 8.06712 14.5321 7.31225C13.8924 6.55737 13.0897 5.95746 12.1846 5.55768C11.2794 5.1579 10.2954 4.96867 9.30653 5.00423C8.31767 5.03979 7.34976 5.29922 6.47566 5.76298C5.60157 6.22675 4.84408 6.88276 4.26021 7.68164C3.67634 8.48052 3.2813 9.40145 3.10485 10.3751C2.9284 11.3487 2.97512 12.3497 3.24151 13.3027C3.50789 14.2557 3.98699 15.1358 4.64274 15.8768",
    stroke: "#344054",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadCloud);
export default __webpack_public_path__ + "static/media/downloadCloud.4bd3db70cfcdff8ea905e06d86bbc7cd.svg";
export { ForwardRef as ReactComponent };